import fetch from "isomorphic-fetch";
import { message, setIsFetching, setCreatedTreeKey } from "../../../actions";
import { getBlocks } from "./Blocks";
import Configuration from "../../../config.js";
import ReactGA from "react-ga";

/**
 * Konstanten
 */
export const SET_QUESTIONS = "SET_QUESTIONS";
export const SET_NEXT_QUESTION_SORT_ID = "SET_NEXT_QUESTION_SORT_ID";
export const SET_BLOCK_QUESTIONS = "SET_BLOCK_QUESTIONS";

/**
 * Setter
 */
export function setQuestions( json )
{
	return {
		type: SET_QUESTIONS,
		json
	};
}

export function setNextQuestionSortId( block_id, sort_id )
{
	return {
		type: SET_NEXT_QUESTION_SORT_ID,
		block_id,
		sort_id
	};
}

export function setBlockQuestions( questionnaire_id, block_id, json )
{
	return {
		type: SET_BLOCK_QUESTIONS,
		questionnaire_id,
		block_id,
		json
	};
}

/**
 * Zeigt den gewählten Frage
 * @template Vorlage
 *
 * @param id {number}
 * @param block_id {number}
 * @param questionnaire_id {number}
 */
export function getQuestion( id, block_id, questionnaire_id )
{
	return function( dispatch, getState )
	{
		dispatch( setIsFetching( true ) );
		
		const jwt = getState().jwt;
		let headers = jwt !== null ? { "JWT": jwt } : {};
		
		return fetch(
			`${Configuration.apiUrl}/admin/questionnaires/${questionnaire_id}/blocks/${block_id}/questions/${id}?${+new Date()}`,
			{
				credentials: "include",
				method: "GET",
				headers
			}
		)
			.then(
				response =>
				{
					if ( response.ok )
					{
						response.json()
							.then( json =>
								{
									dispatch( setBlockQuestions( questionnaire_id, block_id, json ) );
								}
							);
					}
					else
					{
						response.json()
							.then( json =>
								{
									// Der Nutzer erfährt warum die Anfrage fehlgeschlagen ist.
									dispatch( message( json.error, "error" ) );
								}
							);
					}
					
					dispatch( setIsFetching( false ) );
				}
			)
			.catch(
				error =>
				{
					dispatch( message( "Der Dienst steht derzeit nicht zur Verfügung. Bitte versuchen Sie es später erneut.", "error" ) );
					dispatch( setIsFetching( false ) );
				}
			);
	};
	
} // function getQuestion(...)

/**
 * Zeigt alle Fragebögen in der Übersicht an
 *
 * @param {number} block_id             Block Id
 * @param {number} questionnaire_id     Umfrage Id
 * @param {String} a_created_key        Angelegter Key
 */
export function getBlockQuestions( block_id, questionnaire_id, a_created_key = null )
{
	return function( dispatch, getState )
	{
		dispatch( setIsFetching( true ) );
		
		// Google Analytics
		if ( localStorage.getItem( "ga" ) )
		{
			ReactGA.event( {
				category: "Question",
				action: "Blockfragen laden"
			} );
		}
		
		const jwt = getState().jwt;
		let headers = jwt !== null ? { "JWT": jwt } : {};
		
		return fetch(
			`${Configuration.apiUrl}/admin/questionnaires/${questionnaire_id}/blocks/${block_id}/questions?${+new Date()}`,
			{
				credentials: "include",
				method: "GET",
				headers
			}
		)
			.then(
				response =>
				{
					if ( response.ok )
					{
						response.json()
							.then( json =>
								{
									let questions = getState().questions[questionnaire_id];
									
									Object.keys( json ).forEach(
										( a_key ) =>
										{
											questions[a_key] = json[a_key];
										}
									);
									
									// Fragen aktualisieren
									dispatch( setQuestions( { [questionnaire_id]: questions } ) );
									dispatch( setBlockQuestions( questionnaire_id, block_id, json ) );
									
									// Wenn zuvor eine Frage angelegt wurde
									if ( a_created_key )
									{
										dispatch( setCreatedTreeKey( a_created_key ) );
									}
								}
							);
					}
					else
					{
						response.json()
							.then( json =>
								{
									// Der Nutzer erfährt warum die Anfrage fehlgeschlagen ist.
									dispatch( message( json.error, "error" ) );
								}
							);
					}
					
					dispatch( setIsFetching( false ) );
				}
			)
			.catch(
				error =>
				{
					dispatch( message( "Der Dienst steht derzeit nicht zur Verfügung. Bitte versuchen Sie es später erneut.", "error" ) );
					dispatch( setIsFetching( false ) );
				}
			);
	};
	
} // function getBlockQuestions(...)

/**
 * Zeigt die nächste Sortier Id an
 * @deprecated
 *
 * @param block_id {number}
 * @param questionnaire_id {number}
 */
export function getNextQuestionSortId( block_id, questionnaire_id )
{
	return function( dispatch, getState )
	{
		dispatch( setIsFetching( true ) );
		
		const jwt = getState().jwt;
		let headers = jwt !== null ? { "JWT": jwt } : {};
		
		return fetch(
			`${Configuration.apiUrl}/admin/questionnaires/${questionnaire_id}/blocks/${block_id}/next-question-sort-id?${+new Date()}`,
			{
				credentials: "include",
				method: "GET",
				headers
			}
		)
			.then(
				response =>
				{
					if ( response.ok )
					{
						response.json()
							.then( sort_id =>
								{
									dispatch( setNextQuestionSortId( block_id, sort_id ) );
								}
							);
					}
					else
					{
						response.json()
							.then( json =>
								{
									dispatch( setNextQuestionSortId( null ) );
									
									// Der Nutzer erfährt warum die Anfrage fehlgeschlagen ist.
									dispatch( message( json.error, "error" ) );
								}
							);
					}
					
					dispatch( setIsFetching( false ) );
				}
			)
			.catch(
				error =>
				{
					dispatch( setNextQuestionSortId( null ) );
					dispatch( message( "Der Dienst steht derzeit nicht zur Verfügung. Bitte versuchen Sie es später erneut.", "error" ) );
					dispatch( setIsFetching( false ) );
				}
			);
	};
	
} // function getNextQuestionSortId(...)

/**
 * Zeigt alle Fragebögen in der Übersicht an
 * @template Die Vorlage wird derzeit nicht benötigt.
 *
 */
export function getQuestions( questionnaire_id )
{
	return function( dispatch, getState )
	{
		dispatch( setIsFetching( true ) );
		
		const jwt = getState().jwt;
		let headers = jwt !== null ? { "JWT": jwt } : {};
		
		return fetch(
			`${Configuration.apiUrl}/admin/questionnaires/${questionnaire_id}/questions?${+new Date()}`,
			{
				credentials: "include",
				method: "GET",
				headers
			}
		)
			.then(
				response =>
				{
					if ( response.ok )
					{
						response.json()
							.then( json =>
								{
									dispatch( setQuestions( { [questionnaire_id]: json } ) );
								}
							);
					}
					else
					{
						response.json()
							.then( json =>
								{
									// Der Nutzer erfährt warum die Anfrage fehlgeschlagen ist.
									dispatch( message( json.error, "error" ) );
								}
							);
					}
					
					dispatch( setIsFetching( false ) );
				}
			)
			.catch(
				error =>
				{
					dispatch( message( "Der Dienst steht derzeit nicht zur Verfügung. Bitte versuchen Sie es später erneut.", "error" ) );
					dispatch( setIsFetching( false ) );
				}
			);
	};
	
} // function getQuestions(...)

/**
 * Api-Anfrage: Neuen Frage erstellen
 *
 * @param a_formData {Object}
 */
export function createQuestions( a_formData )
{
	return function( dispatch, getState )
	{
		dispatch( setIsFetching( true ) );
		
		// Google Analytics
		if ( localStorage.getItem( "ga" ) )
		{
			ReactGA.event( {
				category: "Question",
				action: "Frage anlegen"
			} );
		}
		
		const jwt = getState().jwt;
		let headers = jwt !== null ? { "JWT": jwt } : {};
		headers["content-type"] = "application/json";
		
		return fetch(
			`${Configuration.apiUrl}/admin/questions`,
			{
				credentials: "include",
				method: "POST",
				body: JSON.stringify( a_formData ),
				headers
			}
		)
			.then(
				response =>
				{
					// Frage angelegt
					if ( response.ok )
					{
						
						// Angelegte ID merken
						response.json()
							.then( json =>
								{
									// Da es nach erfolgreicher Erstellung neue Fragen gibt, wird erneut die Api aufgerufen um Sie in den Store zu laden.
									dispatch( getBlockQuestions( a_formData.block_id, a_formData.questionnaire_id, `menuTree-questions-${json}` ) );
								}
							);
						
						// Der Nutzer soll ein Alert erhalten, dass die Anfrage erfolgreich war.
						dispatch( message( "Frage erfolgreich angelegt.", "info", 5000 ) );
					}
					// Eingabefehler oder Serverfehler
					else
					{
						response.json()
							.then( json =>
								{
									// Der Nutzer erfährt warum die Anfrage fehlgeschlagen ist.
									dispatch( message( json.error, "error" ) );
								}
							);
					}
					
					dispatch( setIsFetching( false ) );
				}
			)
			.catch(
				error =>
				{
					dispatch( message( "Der Dienst steht derzeit nicht zur Verfügung. Bitte versuchen Sie es später erneut.", "error" ) );
					dispatch( setIsFetching( false ) );
				}
			);
	};
	
} // function createQuestions(...)

/**
 * Api-Anfrage: Frage bearbeiten
 *
 * @param a_formData {Object}
 * @param a_question_id {string|number}
 * @param a_block_id {string|number}
 * @param a_questionnaire_id {string|number}
 * @param a_params {string}
 */
export function patchQuestions( a_formData, a_question_id, a_block_id, a_questionnaire_id, a_params )
{
	return function( dispatch, getState )
	{
		dispatch( setIsFetching( true ) );
		
		// Google Analytics
		if ( localStorage.getItem( "ga" ) )
		{
			ReactGA.event( {
				category: "Question",
				action: "Frage bearbeiten"
			} );
		}
		
		const params = a_params ? "?" + a_params : "";
		
		const jwt = getState().jwt;
		let headers = jwt !== null ? { "JWT": jwt } : {};
		headers["content-type"] = "application/json";
		
		return fetch(
			`${Configuration.apiUrl}/admin/questionnaires/${a_questionnaire_id}/questions/${a_question_id}${params}`,
			{
				credentials: "include",
				method: "PATCH",
				headers,
				body: JSON.stringify( a_formData )
			}
		)
			.then(
				response =>
				{
					// Frage aktualisiert
					if ( response.ok )
					{
						// Nach erfolgreicher Änderung die Fragen erneut in den Store zu laden.
						dispatch( getBlockQuestions( a_block_id, a_questionnaire_id ) );
						
						// Die Blöcke müssen auch erneut geladen werden
						dispatch( getBlocks( a_questionnaire_id ) );
						
						// Der Nutzer soll ein Alert erhalten, dass die Anfrage erfolgreich war.
						switch ( a_params )
						{
							case "sort":
								dispatch( message( "Die Frage wurde verschoben.", "info", 5000 ) );
								break;
							case "move":
								dispatch( getBlockQuestions( a_formData.block_id, a_questionnaire_id ) );
								dispatch( message( "Die Frage wurde verschoben.", "info", 5000 ) );
								break;
							default:
								dispatch( message( "Die Frage wurde erfolgreich geändert.", "info", 5000 ) );
						}
						
					}
					// Eingabefehler oder Serverfehler
					else
					{
						response.json()
							.then( json =>
								{
									// Der Nutzer erfährt warum die Anfrage fehlgeschlagen ist.
									dispatch( message( json.error, "error" ) );
								}
							);
					}
					
					dispatch( setIsFetching( false ) );
				}
			)
			.catch(
				error =>
				{
					dispatch( message( "Der Dienst steht derzeit nicht zur Verfügung. Bitte versuchen Sie es später erneut.", "error" ) );
					dispatch( setIsFetching( false ) );
				}
			);
	};
	
} // function patchQuestions(...)

/**
 * Api-Anfrage: Frage löschen
 *
 * @param id {number}
 * @param questionnaire_id {number}
 * @param block_id {number}
 */
export function deleteQuestions( id, questionnaire_id, block_id )
{
	return function( dispatch, getState )
	{
		dispatch( setIsFetching( true ) );
		
		// Google Analytics
		if ( localStorage.getItem( "ga" ) )
		{
			ReactGA.event( {
				category: "Question",
				action: "Frage löschen"
			} );
		}
		
		const jwt = getState().jwt;
		let headers = jwt !== null ? { "JWT": jwt } : {};
		
		return fetch(
			`${Configuration.apiUrl}/admin/questionnaires/${questionnaire_id}/questions/${id}`,
			{
				credentials: "include",
				method: "DELETE",
				headers
			}
		)
			.then(
				response =>
				{
					if ( response.ok )
					{
						// Frage aus dem State löschen
						const stateQuestions = getState().questions[questionnaire_id];
						const questions = {};
						Object.keys( stateQuestions ).forEach( a_key =>
							{
								if ( stateQuestions[a_key].id !== id )
								{
									questions[a_key] = stateQuestions[a_key];
								}
							}
						);
						dispatch( setQuestions( { [questionnaire_id]: questions } ) );
						
						// Da es nach erfolgreicher Erstellung neue Fragebögen gibt, wird erneut die Api aufgerufen um Sie in den Store zu laden.
						dispatch( getBlockQuestions( block_id, questionnaire_id ) );
						
						// Der Nutzer soll ein Alert erhalten, dass die Anfrage erfolgreich war.
						dispatch( message( "Frage erfolgreich gelöscht.", "info", 5000 ) );
					}
					else
					{
						response.json()
							.then( json =>
								{
									// Der Nutzer erfährt warum die Anfrage fehlgeschlagen ist.
									dispatch( message( json.error, "error" ) );
								}
							);
					}
					
					dispatch( setIsFetching( false ) );
				}
			)
			.catch(
				error =>
				{
					dispatch( message( "Der Dienst steht derzeit nicht zur Verfügung. Bitte versuchen Sie es später erneut.", "error" ) );
					dispatch( setIsFetching( false ) );
				}
			);
	};
	
} // function deleteQuestions(...)